import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  IconButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommonButton from "../../../components/CommonButton/CommonButton";
import { DialogProps } from "./types";

const RefreshDialog: React.FC<DialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !loading && onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
            Confirm Refresh
          </Typography>
          <IconButton onClick={() => !loading && onClose()} disabled={loading}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to refresh the data? This will reload all videos
          and business details.
        </Typography>
      </DialogContent>
      <DialogActions>
        <CommonButton onClick={() => !loading && onClose()} disabled={loading}>
          Cancel
        </CommonButton>
        <CommonButton
          onClick={onConfirm}
          disabled={loading}
          isLoading={loading}
        >
          {loading ? "Refreshing..." : "Refresh"}
        </CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default RefreshDialog;
